import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 bg-[#302f2c] rounded-full p-1">
      <button
        onClick={() => setLanguage('en')}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold transition-all duration-300 ${
          language === 'en'
            ? 'bg-[#7dd3fc] text-[#1a1c1b]'
            : 'text-[#888680] hover:text-[#7dd3fc]'
        }`}
      >
        EN
      </button>
      <button
        onClick={() => setLanguage('es')}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold transition-all duration-300 ${
          language === 'es'
            ? 'bg-[#7dd3fc] text-[#1a1c1b]'
            : 'text-[#888680] hover:text-[#7dd3fc]'
        }`}
      >
        ES
      </button>
    </div>
  );
};

export default LanguageSwitcher;
